// import gsap from "gsap";
import Choices from "choices.js";
import Readmore from "readmore-js";

// Read More github
// @link https://github.com/jedfoster/Readmore.js/tree/version-3.0

(function($) {

    const mobile_width = 767;
    let screen_width = $(window).width();
    $(window).on('resize', () => screen_width = $(window).width());


    /**
     * Fix header spacing
     */
    const $siteHeader = $('.siteHeader');
    const $elementsAddSpacing = $('.element--addHeaderSpacing');
    if ( $elementsAddSpacing.length ) {
        $elementsAddSpacing.each(function(){ 
            const el = $(this);
            addHeaderSpacing(el)
            $(window).on('resize', function(){ addHeaderSpacing(el) });
        });
    }
    function addHeaderSpacing($element) {
        if ( typeof $element.data('initial-height') == 'undefined' ) {
            $element.data('initial-height', parseInt($element.css('padding-top')));
        }
        const initialHeight = $element.data('initial-height');
        const siteHeaderHeight = $siteHeader.length ? $siteHeader.outerHeight() : 0;
        $element.css('padding-top', (initialHeight + siteHeaderHeight) + 'px');
    }


    /**
     * Select Dropdowns
     */
	const $selects = $('select');
    $selects.each(function(){
        // Handle tab selects only on mobile
        if ( $(this).hasClass('bde-tabs__select') && screen_width > mobile_width ) {
            return;
        }

        const choices = new Choices($(this)[0], {
            allowHTML: true,
            searchEnabled: false
        });
    });



    /**
     * Mobile Menu:
     * When clicking on dropdown links the first time, open the dropdown instead
     */
    const $mobileDropdownItems = $('.mobileOverlay .breakdance-dropdown > .breakdance-dropdown-toggle > .breakdance-menu-link');
    $mobileDropdownItems.on('click', function(e){
        const $wrapper = $(this).parents('.breakdance-dropdown');
        if ( !$wrapper.hasClass('breakdance-dropdown--open') ) {
            e.preventDefault();
            $(this).siblings('.breakdance-menu-link-arrow').trigger('click');
        }
        
    });


    

    /**
     * Read More collapses
     */
    window.almComplete = function(alm){
        const $readmores = $('.element--readMore');
        if ( $readmores.length ) {
            new Readmore('.element--readMore', {
                speed: 150,
                collapsedHeight: 150,
                heightMargin: 50,
                moreLink: '<a class="eventItem__readMoreBtn" href="#">Read more</a>',
                lessLink: '<a class="eventItem__readMoreBtn" href="#">Read less</a>'
            });
        }
        
    };


    /**
     * Horizontal scrolls on Elections table
     */
    const $tables = $('.onaTable');
    $tables.each(function(){
        const $table = $(this);
        const $wrapper = $table.parents('.onaTable__wrapper');
        const $inner = $table.parents('.onaTable__inner');
        const $topScroller = $wrapper.find('.onaTable__topScroller');
        const $topScrollerInner = $topScroller.children('div');
        let tableWidth = $table.width();

        tableWidth = adjustTableScroller($table, $topScrollerInner);
        $(window).on('resize', () => adjustTableScroller($table, $topScrollerInner));

        $topScroller.on('scroll', function () {
            $inner.scrollLeft($topScroller.scrollLeft());
            checkTableScrollPercentage($inner, tableWidth, $wrapper);
        });
        $inner.on('scroll', function () {
            $topScroller.scrollLeft($inner.scrollLeft());
            checkTableScrollPercentage($inner, tableWidth, $wrapper);
        });

    });

    function adjustTableScroller($table, $scroller) {
        const tableWidth = $table.width();
        $scroller.width(tableWidth);
        return tableWidth;
    }

    function checkTableScrollPercentage($inner, tableWidth, $wrapper) {
        let scrollPercentage;
        const finishedClass = 'onaTable__wrapper--end';
        scrollPercentage = 100 * $inner.scrollLeft() / (tableWidth - $inner.width());
        if ( scrollPercentage == 100 ) {
            $wrapper.addClass(finishedClass);
        } else if ($wrapper.hasClass(finishedClass)) {
            $wrapper.removeClass(finishedClass);
        }
    }

	
})( jQuery );

